import { Action } from '@ngrx/store';

export class EmptyAction implements Action {
  public readonly type = 'NOACTION';
}
